import { Pagination, Icon, Button, TextField, EmptyState, Card, BlockStack, InlineStack } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import {
    SearchMinor,
} from '@shopify/polaris-icons';
import { DI, DIProps } from '../../../../Core';
import { Table } from 'antd';
import NoResultsFound from '../../../../Asests/Images/NoResultsFound.png'
interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

const gridColumns = [
    {
        title: 'Shopify Order ID',
        dataIndex: 'shopify_order_id',
    },
    {
        title: 'Amazon Order ID',
        dataIndex: 'amazon_order_id',
        width: '20%'
    },
    {
        title: 'App Created On',
        dataIndex: 'app_created_on',
    },
    {
        title: 'Amazon Created On',
        dataIndex: 'amazon_created_on',
    },
    {
        title: 'Shopify Created On',
        dataIndex: 'shopify_created_on',
    },
    {
        title: 'Reason',
        dataIndex: 'reason',
    },
    {
        title: 'Action',
        dataIndex: 'action',
        width: '20%'
    }
];

function UnshippedOrders(props: Props) {
    const [totalPages, setTotalPages] = useState<number>(0);
    const [activePage, setActivePage] = useState<number>(1);
    const [pageCount, setpageCount] = useState<number>(10);
    const [searchValue, setsearchValue] = useState<string>('');
    const [loader, setLoader] = useState<boolean>(false);
    const [gridRows, setgridRows] = useState<any>([]);
    const [showSkeleton, setShowSkeleton] = useState<boolean>(false);

    const handlePreviousPagination = () => {
        setActivePage(prev => prev - 1);
    }

    const handleNextPagination = () => {
        setActivePage(prev => prev + 1);
    }

    const getRefundOrders = async () => {
        setLoader(true);
        let obj: any = { activePage: activePage, count: pageCount };
        let response = await props.di.GET('connector/order/getAllFailedRefunds', obj);
        setLoader(false);
        if (response.success && response?.data?.rows?.length > 0) {
        }
        else {
            setShowSkeleton(true);
        }
    }

    const handleSearchClick = () => {
        searchValue != "" && searchValue.trim().length > 0 && setLoader(true);
        searchValue != "" && searchValue.trim().length > 0 && props.di.GET('connector/order/getAllFailedRefunds', {
            'filter[marketplace_reference_id][1]': searchValue
        }).then((response: any) => {
            if (response.success && response?.data?.rows?.length > 0) {
            }
            else {
                setShowSkeleton(true);
            }
            setLoader(false);
        })
    }

    useEffect(() => {
        getRefundOrders()
    }, [activePage]);

    useEffect(() => {
        if (searchValue == "") {
            getRefundOrders();
        }
    }, [searchValue]);

    return (
        <React.Fragment>
            <Card roundedAbove='sm'>
                <BlockStack gap="200">
                    <InlineStack gap="100">
                        <div className='Custom-Stack-Item--fill'>
                            <TextField
                                autoComplete='off'
                                prefix={<Icon source={SearchMinor} tone="base" />}
                                label={''}
                                labelHidden
                                value={searchValue}
                                onChange={(e) => { setsearchValue(e) }}
                                placeholder="Search with Amazon Order Id"
                            />
                        </div>
                        <Button onClick={handleSearchClick} disabled={loader}>Search</Button>
                        {searchValue != "" && <Button onClick={() => { }} disabled={loader}  variant="primary" tone="critical">Clear</Button>}
                    </InlineStack>
                    {showSkeleton ? <InlineStack gap="400" align="center">
                        <EmptyState
                            image={NoResultsFound}
                            heading={"No Failed Refund Orders Found!"}
                        />
                    </InlineStack> :
                        <Table
                            columns={gridColumns}
                            dataSource={gridRows}
                            scroll={{ x: 920, }}
                            pagination={false}
                            loading={loader}
                        />}
                    {gridRows.length > 0 &&
                        <InlineStack align="center">
                            <Pagination
                                label={`${activePage}/${totalPages}`}
                                hasPrevious={activePage > 1}
                                onPrevious={() => {
                                    handlePreviousPagination()
                                }}
                                hasNext={activePage < totalPages}
                                onNext={() => {
                                    handleNextPagination()
                                }}
                            />
                        </InlineStack>
                    }
                </BlockStack>
            </Card>
        </React.Fragment>
    );
}
export default DI(UnshippedOrders);